import { Reveal } from "@/lib/motion";

const VALUES = ["Rigueur", "Confidentialité", "Expertise", "Accompagnement"];

export default function About({ aboutImg }) {
  return (
    <section id="apropos" className="py-24 md:py-32" data-testid="section-apropos">
      <div className="mx-auto grid max-w-6xl gap-12 px-5 lg:grid-cols-[0.85fr_1.15fr] lg:items-center">
        <Reveal>
          <div className="overflow-hidden rounded-3xl border border-white/10 bg-white shadow-[0_24px_60px_rgba(0,0,0,0.35)]">
            <img src="/logo_korban_consulting.png" alt="KORBAN CONSULTING" className="w-full object-contain p-8" />
          </div>
          <div className="relative mt-5 overflow-hidden rounded-3xl">
            <img
              src={aboutImg ? `${window.location.origin}/api/public/img/${aboutImg}` : "https://images.unsplash.com/photo-1758519288358-86c504767112?auto=format&fit=crop&w=1200&q=80"}
              alt="Consultants KORBAN CONSULTING en réunion"
              className="aspect-[16/9] w-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-korban-navy/70 to-transparent" />
            <p className="absolute bottom-4 left-5 text-sm font-semibold text-white">Yopougon, Abidjan — Côte d'Ivoire</p>
          </div>
        </Reveal>

        <Reveal delay={0.12}>
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-korban-gold">À propos</p>
          <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Votre partenaire unique de confiance
          </h2>
          <div className="mt-5 h-1 w-16 rounded-full bg-korban-gold" />
          <p className="mt-6 text-lg leading-relaxed text-slate-300">
            KORBAN CONSULTING accompagne entreprises et institutions dans la gestion de leurs ressources humaines, de
            leur comptabilité, de leur paie, de leur fiscalité et de leur transformation numérique. Notre approche :
            rigueur, confidentialité et conseils concrets.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            {VALUES.map((v) => (
              <span
                key={v}
                className="rounded-full border border-korban-gold/40 bg-korban-gold/10 px-5 py-2.5 text-sm font-bold text-korban-gold"
              >
                {v}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
